import moment from "moment"

export default ({ pageTitle, pageDescription, url, date, image }) => {
  const structuredJson = {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": url,
    },
    headline: pageTitle,
    image: [image],
    datePublished: `${moment(date, "YYYY年MM月DD日").format(
      "YYYY-MM-DD"
    )}T08:00:00`,
    dateModified: moment(),
    author: {
      "@type": "Person",
      name: "Coichiro Aso",
    },
    publisher: {
      "@type": "Organization",
      name: "Coichiro Aso",
      logo: {
        "@type": "ImageObject",
        url: "https://slipnote.net/assets/icons/logo.jpg",
      },
    },
    description: pageDescription,
  }
  return structuredJson
}
